import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Language = "en" | "es-AR" | "pt-BR";

interface LanguageStore {
  currentLanguage: Language;
  setLanguage: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      currentLanguage: "pt-BR",
      setLanguage: (lang) => set({ currentLanguage: lang }),
    }),
    {
      name: "language-storage",
    }
  )
);
